"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setByPath = function setByPath(object, pathArr, value) {
  var length = pathArr.length;
  var lastIndex = length - 1;
  var index = -1;
  var nested = object;

  while (nested != null && ++index < length) {
    var key = pathArr[index];

    if (index !== lastIndex) {
      var objValue = nested[key] || {};
      nested[key] = objValue;
    } else {
      nested[key] = value;
    }

    nested = nested[key];
  }

  return object;
};

var set = function set(object, pathInput, value) {
  if (!object) {
    return object;
  }

  try {
    return setByPath(object, typeof pathInput === 'string' ? pathInput.split('.') : pathInput, value);
  } catch (e) {
    console.error("Can't set ".concat(value, " by path:"), pathInput);
  }
};

var _default = set;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9zZXQudHMiXSwibmFtZXMiOlsic2V0QnlQYXRoIiwib2JqZWN0IiwicGF0aEFyciIsInZhbHVlIiwibGVuZ3RoIiwibGFzdEluZGV4IiwiaW5kZXgiLCJuZXN0ZWQiLCJrZXkiLCJvYmpWYWx1ZSIsInNldCIsInBhdGhJbnB1dCIsInNwbGl0IiwiZSIsImNvbnNvbGUiLCJlcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBLElBQU1BLFNBQVMsR0FBRyxTQUFaQSxTQUFZLENBQUNDLE1BQUQsRUFBU0MsT0FBVCxFQUFrQkMsS0FBbEIsRUFBNEI7QUFDNUMsTUFBTUMsTUFBTSxHQUFHRixPQUFPLENBQUNFLE1BQXZCO0FBQ0EsTUFBTUMsU0FBUyxHQUFHRCxNQUFNLEdBQUcsQ0FBM0I7QUFDQSxNQUFJRSxLQUFLLEdBQUcsQ0FBQyxDQUFiO0FBQ0EsTUFBSUMsTUFBTSxHQUFHTixNQUFiOztBQUNBLFNBQU9NLE1BQU0sSUFBSSxJQUFWLElBQWtCLEVBQUVELEtBQUYsR0FBVUYsTUFBbkMsRUFBMkM7QUFDekMsUUFBTUksR0FBRyxHQUFHTixPQUFPLENBQUNJLEtBQUQsQ0FBbkI7O0FBQ0EsUUFBSUEsS0FBSyxLQUFLRCxTQUFkLEVBQXlCO0FBQ3ZCLFVBQU1JLFFBQVEsR0FBR0YsTUFBTSxDQUFDQyxHQUFELENBQU4sSUFBZSxFQUFoQztBQUNBRCxNQUFBQSxNQUFNLENBQUNDLEdBQUQsQ0FBTixHQUFjQyxRQUFkO0FBQ0QsS0FIRCxNQUdPO0FBQ0xGLE1BQUFBLE1BQU0sQ0FBQ0MsR0FBRCxDQUFOLEdBQWNMLEtBQWQ7QUFDRDs7QUFDREksSUFBQUEsTUFBTSxHQUFHQSxNQUFNLENBQUNDLEdBQUQsQ0FBZjtBQUNEOztBQUNELFNBQU9QLE1BQVA7QUFDRCxDQWhCRDs7QUFpQkEsSUFBTVMsR0FBRyxHQUFHLFNBQU5BLEdBQU0sQ0FBQ1QsTUFBRCxFQUFTVSxTQUFULEVBQW9CUixLQUFwQixFQUE4QjtBQUN4QyxNQUFJLENBQUNGLE1BQUwsRUFBYTtBQUFFLFdBQU9BLE1BQVA7QUFBZ0I7O0FBQy9CLE1BQUk7QUFDRixXQUFPRCxTQUFTLENBQUNDLE1BQUQsRUFBUyxPQUFPVSxTQUFQLEtBQXFCLFFBQXJCLEdBQWdDQSxTQUFTLENBQUNDLEtBQVYsQ0FBZ0IsR0FBaEIsQ0FBaEMsR0FBdURELFNBQWhFLEVBQTJFUixLQUEzRSxDQUFoQjtBQUNELEdBRkQsQ0FFRSxPQUFNVSxDQUFOLEVBQVM7QUFDVEMsSUFBQUEsT0FBTyxDQUFDQyxLQUFSLHFCQUEyQlosS0FBM0IsZ0JBQTZDUSxTQUE3QztBQUNEO0FBQ0YsQ0FQRDs7ZUFTZUQsRyIsInNvdXJjZXNDb250ZW50IjpbIlxuY29uc3Qgc2V0QnlQYXRoID0gKG9iamVjdCwgcGF0aEFyciwgdmFsdWUpID0+IHtcbiAgY29uc3QgbGVuZ3RoID0gcGF0aEFyci5sZW5ndGg7XG4gIGNvbnN0IGxhc3RJbmRleCA9IGxlbmd0aCAtIDE7XG4gIGxldCBpbmRleCA9IC0xO1xuICBsZXQgbmVzdGVkID0gb2JqZWN0O1xuICB3aGlsZSAobmVzdGVkICE9IG51bGwgJiYgKytpbmRleCA8IGxlbmd0aCkge1xuICAgIGNvbnN0IGtleSA9IHBhdGhBcnJbaW5kZXhdO1xuICAgIGlmIChpbmRleCAhPT0gbGFzdEluZGV4KSB7XG4gICAgICBjb25zdCBvYmpWYWx1ZSA9IG5lc3RlZFtrZXldIHx8IHt9O1xuICAgICAgbmVzdGVkW2tleV0gPSBvYmpWYWx1ZTtcbiAgICB9IGVsc2Uge1xuICAgICAgbmVzdGVkW2tleV0gPSB2YWx1ZTtcbiAgICB9XG4gICAgbmVzdGVkID0gbmVzdGVkW2tleV07XG4gIH1cbiAgcmV0dXJuIG9iamVjdDtcbn1cbmNvbnN0IHNldCA9IChvYmplY3QsIHBhdGhJbnB1dCwgdmFsdWUpID0+IHtcbiAgaWYgKCFvYmplY3QpIHsgcmV0dXJuIG9iamVjdDsgfVxuICB0cnkge1xuICAgIHJldHVybiBzZXRCeVBhdGgob2JqZWN0LCB0eXBlb2YgcGF0aElucHV0ID09PSAnc3RyaW5nJyA/IHBhdGhJbnB1dC5zcGxpdCgnLicpIDogcGF0aElucHV0LCB2YWx1ZSlcbiAgfSBjYXRjaChlKSB7XG4gICAgY29uc29sZS5lcnJvcihgQ2FuJ3Qgc2V0ICR7dmFsdWV9IGJ5IHBhdGg6YCwgcGF0aElucHV0KTtcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBzZXQ7XG4iXX0=